import { createSlice } from "@reduxjs/toolkit";

const initialState = () => {
  const savedState = JSON.parse(localStorage.getItem("ageSate"));
  return savedState || { items: ["18+", "0-2", "3-5", "6-8", "9-12", "12-17"] };
};

const ageState = createSlice({
  name: "AgeState",
  initialState: initialState,
  reducers: {
    addAge(state, action) {
      if (action.payload) {
        state.items.push(action.payload);
        localStorage.setItem("ageSate", JSON.stringify(state));
      }
    },
  },
});

export const { addAge } = ageState.actions;
export const ageReducer = ageState.reducer;
